export default __webpack_public_path__ + "static/hello_there-fa0f6a8950d22960597362ece461fd5c.gif";